export default {
  term_only: 'โดยการส่งคำขอผ่านแบบฟอร์ม คุณได้ยอมรับ<1>ข้อตกลงในการใช้งาน</1>',
  privacy_only:
    'โดยการส่งคำขอผ่านแบบฟอร์ม คุณได้ยอมรับ<1>นโยบายการรักษาข้อมูลส่วนบุคคล</1>',
  term_privacy:
    'โดยการส่งคำขอผ่านแบบฟอร์ม คุณได้ยอมรับ<1>ข้อตกลงในการใช้งาน</1> และ <3>นโยบายการรักษาข้อมูลส่วนบุคคล</3>',
}
